import React, {useEffect} from 'react';
import InfoCircle from '@mui/icons-material/InfoRounded';
import {Form, Table} from 'react-bootstrap';

const DSMR5Table = (props) => (
  <Table>
    <tbody>
    <tr>
      <th className="text-start"><span>Name</span></th>
      <td className="text-end">{props.device.name}</td>
    </tr>
    <tr>
      <th className="text-start"><span>USB Device</span></th>
      <td className="text-end">{props.device.usbDevice}</td>
    </tr>
    </tbody>
  </Table>
);
const DSMR5Form = (props) => {
  useEffect(() => {
    props.setSaveDisabled(!(props.device.name && props.device.usbDevice));
  }, [props.device]);
  return (
    <Form>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control type="text" name="name" value={props.device.name} onChange={props.handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>
          USB Device{' '}
          <a
            href="https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#error%2C-usbDevice"
            target="_blank" rel="noopener noreferrer">
            <InfoCircle style={{fontSize: 14}}/>
          </a>
        </Form.Label>
        <Form.Control type="text" name="usbDevice" value={props.device.usbDevice} onChange={props.handleChange}/>
      </Form.Group>
    </Form>
  );
};
export {DSMR5Table, DSMR5Form};
